/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.FAQCategoriesResponse, () => void, () => void];

function useFetchFAQCategories({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [response, setResponse] = useState<vp.FAQCategoriesResponse>({
    ErrorMessage: '',
    Success: false,
    FAQCategories: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  useEffect(() => {
    const sendRequest = async () => {
      const res = await api.fetchFAQCategories(source);
      setResponse(res);
      setSendRequest(false);
      return () => {};
    };
    if (shouldSendRequest) void sendRequest();
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);
  return [
    response,
    () => {
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setResponse({
        ErrorMessage: '',
        Success: false,
        FAQCategories: {},
      });
    },
  ];
}
export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchFAQCategories);
